/// <amd-module name="VSSUI/SuggestionsList" />
export { SuggestionsItem, SuggestionsList } from "./Components/SuggestionsList/SuggestionsList";
export { ISuggestionItemProps, ISuggestionsListProps } from "./Components/SuggestionsList/SuggestionsList.Props";
